<app-pre-loader *ngIf="IsLoadingResults"></app-pre-loader>

<div class="content-wrapper">
    <!-- Main content -->
    <!-- Default box -->
    <div class="box">


        <mat-card>

            <form [formGroup]="GTCForm">
                <mat-card class="btnCard">
                    <mat-card-actions>

                        <button class="btn-primary1" type="button" [disabled]="IsLoadingResults" *ngIf="RecordStatus == 1 
                        ||  (IsFormEditable && IsShownSubmitAndSaveButton)" (click)="onSubmit(1)" mat-stroked-button>
                            Save as Draft
                        </button>
                        <button class="btn-primary1" type="submit" [disabled]="IsLoadingResults" *ngIf="(IsFormEditable  || IsReturnRequest)"
                            (click)="onSubmit(2)" mat-stroked-button>
                            Submit
                        </button>
                        <button class="btn-primary1" type="button" mat-stroked-button
                            (click)="OnCopyAndCreateNewRequest()" *ngIf="RecordStatus == 4 && global.IsEngTeam">
                            Copy
                        </button>
                        <button class="btn-primary1" type="button" mat-stroked-button
                            (click)="ChangeApprovalStatusWithReason(TakeActionOnRequest,Approve)"
                            *ngIf="ShowApprovalButtons">
                            Submit
                        </button>

                        <button class="btn-primary1" type="button" mat-stroked-button *ngIf="ShowApprovalButtons"
                            (click)="SendToTQL(TakeActionOnRequest,PendingWithTQL)">
                            Send To TQL
                        </button>
                        <button class="btn-primary1" type="button" mat-stroked-button *ngIf="ShowApprovalButtons"
                            (click)="ChangeApprovalStatusWithReason(TakeActionOnRequest,Reject)">
                            Reject
                        </button>
                        <button class="btn-primary1" type="button" mat-stroked-button *ngIf="ShowApprovalButtons"
                            (click)="ChangeApprovalStatusWithReason(TakeActionOnRequest,Return)">

                            Return
                        </button>
                        <button class="btn-primary1" type="button" mat-stroked-button *ngIf="ShowApprovalButtons"
                            (click)="ChangeApprovalStatusWithReason(TakeActionOnRequest,PartiallyApprove)">

                            Partially Approve
                        </button>

                        <button class="btn-primary2" type="button" mat-stroked-button *ngIf="ShowApprovalButtons"
                            (click)="ChangeApprovalStatusForInitaialRequest(InitateRequest)">

                            In Progress
                        </button>

                        <button class="btn-primary1" type="button" *ngIf="getFormControls('RecordStatus').value != 1"
                            mat-stroked-button (click)="openAuditTrailDialog()">
                            Audit Trail
                        </button>
                        <button class="btn-primary1" type="button" mat-stroked-button (click)="Exit()">Exit</button>
                    </mat-card-actions>
                </mat-card>
                <mat-card class="card2">
                    <div class="row" style="color:green;">
                        <div class="col-md-5"><b>Request No : </b>{{GTCNo}}</div>
                        <div class="col-md-5" style="right: 0;
                            bottom: 0;
                            position: absolute;
                            text-align-last: end;"><b>Status :</b> {{FormStatusName}}</div>
                    </div>
                </mat-card>

                <mat-card-header>
                    <h6>A PACE ID is required to begin a GTC request process.
                        The PACE can be in any phase, whether it's a draft, pending EP sign-off,
                        or fully completed.</h6>
                    <div class="link-container">
                        <a [disabled]="RecordStatus== 1 || RecordStatus== 0 || RecordStatus== 6" mat-button
                            style="color: blue;" (click)="ExportClauses()">Export to Word</a>

                        <a mat-button color="primary" (click)="navigateToPage()">Click link to view summary of all
                            clauses</a>
                    </div>
                </mat-card-header>
                <fieldset>
                    <mat-tab-group [(selectedIndex)]="selectedTabIndex" (selectedTabChange)="onTabChanged($event);"
                        backgroundColor="accent" animationDuration="1000ms">
                        <mat-tab>
                            <ng-template mat-tab-label>
                                <span class="custom-tab-label">(A) Basic <br>
                                    Information</span>
                            </ng-template>
                            <div class="panel panel-default" style="margin: 10px;">
                                <div class="panel-body">
                                    <!--2. Generic Mandatory Validation Message-->
                                    <ng-container *ngIf="getMissingRequiredFields('basic') as missingFields">
                                        <div class="validation-summary" role="alert" *ngIf="missingFields.length">
                                            <strong>Please complete the following required fields:</strong>
                                            <ul>
                                                <li *ngFor="let field of missingFields">{{ field.label }}</li>
                                            </ul>
                                        </div>
                                    </ng-container>
                                    <!--2. Generic Mandatory Validation Message-->
                                    <div class="row gy-2">
                                        <!-- Row 1 -->
                                        <div class="col-md-6 mb-2">
                                            <label>A1. Contracting Member Firm <span class="required">*</span></label>
                                        </div>

                                        <div class="col-md-6 mb-2">
                                            <label class="d-flex align-items-center">
                                                A2. PACE ID <span class="required">*</span>
                                                <span class="ms-2" mat-raised-button
                                                    matTooltip="Please ensure that PACE ID is in the format – '12345678.1.0'. Spacing and special characters are not permitted.">
                                                    <i class="pi pi-question-circle"></i>
                                                </span>
                                            </label>
                                        </div>

                                        <!-- Row 2 -->
                                        <div class="col-md-5 mb-2">
                                            <p-dropdown [options]="entityNameList" [showClear]="true"
                                                [style]="{'width': '60%'}" appendTo="body" class="Vertical_margin w-100"
                                                (onChange)="onEntityChange($event)" placeholder="Select Entity Name"
                                                formControlName="FirmId">
                                            </p-dropdown>
                                            <br>
                                            <mat-error class="ValidationError ps-2" style="margin-left: 25px;"
                                                *ngIf="getFormControls('FirmId').invalid && (getFormControls('FirmId').dirty || getFormControls('FirmId').touched)">
                                                <span *ngIf="getFormControls('FirmId').errors?.['required']">
                                                    Please select entity name
                                                </span>
                                            </mat-error>
                                        </div>

                                        <div class="col-md-5 offset-md-1 mb-2">
                                            <input class="form-control custom-input" formControlName="PaceID"
                                                maxlength="12" (blur)="onInputBlur($event)" [style]="{'width': '60%'}"
                                                appOnlyDecimal>
                                            <span class="text-danger ps-2 small"
                                                *ngIf="!checkValueIsNullOrEmptyOrUndefined(getFormControls('PaceIdMessage').value)">
                                                {{ getFormControls('PaceIdMessage').value }}
                                            </span>

                                            <mat-error class="ValidationError ps-2" style="margin-left: 25px;"
                                                *ngIf="getFormControls('PaceID').invalid && (getFormControls('PaceID').dirty || getFormControls('PaceID').touched)">
                                                <span *ngIf="getFormControls('PaceID').errors?.['required']">
                                                    Please enter Pace ID
                                                </span>
                                            </mat-error>
                                        </div>

                                        <!-- Row 3 -->
                                        <div class="col-md-6 mb-2">
                                            <label>A3. Sub-Service Line (SSL) <span class="required">*</span></label>
                                        </div>

                                        <div class="col-md-6 mb-2">
                                            <label>A4. Engagement Partner (EP) Location <span
                                                    class="required">*</span></label>
                                        </div>

                                        <!-- Row 4 -->
                                        <div class="col-md-5 mb-2">
                                            <p-dropdown [options]="SSLList" [showClear]="true" appendTo="body"
                                                [style]="{'width': '60%'}" class="Vertical_margin w-100"
                                                placeholder="Select SSL" formControlName="SSL">
                                            </p-dropdown>
                                            <br>
                                            <mat-error class="ValidationError ps-2" style="margin-left: 25px;"
                                                *ngIf="getFormControls('SSL').invalid && (getFormControls('SSL').dirty || getFormControls('SSL').touched)">
                                                <span *ngIf="getFormControls('SSL').errors?.['required']">
                                                    Please select SSL
                                                </span>
                                            </mat-error>
                                        </div>

                                        <div class="col-md-5 offset-md-1 mb-2">
                                            <p-dropdown [options]="LocationList" [showClear]="true"
                                                [style]="{'width': '60%'}" appendTo="body" class="Vertical_margin w-100"
                                                placeholder="Select Location" formControlName="Location">
                                            </p-dropdown>
                                            <br>

                                            <mat-error class="ValidationError ps-2" style="margin-left: 25px;"
                                                *ngIf="getFormControls('Location').invalid && (getFormControls('Location').dirty || getFormControls('Location').touched)">
                                                <span *ngIf="getFormControls('Location').errors?.['required']">
                                                    Please select Location
                                                </span>
                                            </mat-error>
                                        </div>
                                    </div>



                                    <div class="row">
                                        <!-- 10. Client Name Mandatory Validation Missing - Client Name Mandatory Validation Added-->
                                        <div class="mb-3 col-md-6">
                                            <label>A5. Client Name <span class="required">*</span></label>
                                            <input class="form-control col-md-6 custom-input"
                                                formControlName="ClientName" maxlength="100"
                                                [style.width]="getFormControls('ClientName') ? (getFormControls('ClientName').value.length + 1) + 'ch' : 'auto'">
                                            <mat-error class="ValidationError ps-2" style="margin-left: 25px;"
                                                *ngIf="getFormControls('ClientName').invalid && (getFormControls('ClientName').dirty || getFormControls('ClientName').touched)">
                                                <span *ngIf="getFormControls('ClientName').errors?.['required']">
                                                    Please enter client name
                                                </span>
                                            </mat-error>
                                        </div>
                                        <!-- 10. Client Name Mandatory Validation Missing - Client Name Mandatory Validation Added-->
                                        <div class="mb-3 col-md-6">
                                            <label>A6. EP Name</label>
                                            <div class="mb-3 col-md-5">

                                                <!--<input class="form-control" formControlName="EngagementCode" placeholder="Engagement Code">-->
                                                <p-autoComplete [minLength]="4" emptyMessage="No Record Found"
                                                    formControlName="EngPartnerName" [suggestions]="PartnerList"
                                                    emptyMessage="No Record Found" class="Vertical_margin"
                                                    (completeMethod)="SearchPartnerName($event)"
                                                    (onSelect)="getPartnerDetails($event)" [field]="'EmpName'"
                                                    (onClear)="ResetPartnerDetails()"
                                                    placeholder="Search for Eng Partner" [forceSelection]="true">
                                                </p-autoComplete>
                                                <br>

                                                <mat-error style="margin-left: 25px;" *ngIf="getFormControls('EngPartnerName').invalid && 
                                                getFormControls('EngPartnerName').touched" class="ValidationError">
                                                    <mat-error class="mat-error"
                                                        *ngIf="getFormControls('EngPartnerName').errors?.['required']">
                                                        Please enter Eng Partner Name
                                                    </mat-error>
                                                </mat-error>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" style="margin-bottom: -10px;">
                                        <div class="mb-3 col-md-6">
                                            <label>A7. Is the EP signing the Engagement Agreement (EA) different from
                                                the EP </label>
                                            <label style="margin-left: 28px;">listed on PACE?</label>
                                            <span class="required">*</span>

                                        </div>

                                        <div class="mb-3 col-md-6" *ngIf="IsAddEngPartnerRequired">

                                            <label style="display: flex; align-items: center;">A7.1. EP Name per EA
                                                <span class="required">*</span>
                                                &nbsp;

                                            </label>

                                        </div>

                                    </div>
                                    <div class="row">
                                        <div class="mb-3 col-md-6">

                                            <div class="input-group radio-div" style="margin-left:15px;">
                                                <mat-radio-group formControlName="IsPartnerNameRequired"
                                                    (change)="OnEPSigningRequired($event)">
                                                    <mat-radio-button value="1">Yes</mat-radio-button>
                                                    <mat-radio-button value="2">No</mat-radio-button>
                                                </mat-radio-group>
                                            </div>
                                            <mat-error style="margin-left: 25px;"
                                                *ngIf="getFormControls('IsPartnerNameRequired').invalid && (getFormControls('IsPartnerNameRequired').dirty || getFormControls('IsPartnerNameRequired').touched)"
                                                class="ValidationError">
                                                <mat-error class="mat-error"
                                                    *ngIf="getFormControls('IsPartnerNameRequired').errors?.['required']">
                                                    This field is mandatory
                                                </mat-error>
                                            </mat-error>
                                        </div>
                                        <div class="mb-3 col-md-6" *ngIf="IsAddEngPartnerRequired">

                                            <!--<input class="form-control" formControlName="EngagementCode" placeholder="Engagement Code">-->
                                            <p-autoComplete [minLength]="3" emptyMessage="No Record Found"
                                                formControlName="EngPartnerReqName" [suggestions]="EmpPartnerList"
                                                (completeMethod)="SearchPartner($event)" class="Vertical_margin"
                                                (onSelect)="setPartnerGPN($event)" [field]="'extraLabel'"
                                                placeholder="Enter Engagement Partner Name" [forceSelection]="true"
                                                showTransitionOptions="0.5s cubic-bezier(0, 0, 0.2, 1)">
                                                <ng-template let-partner pTemplate="item">
                                                    <div>{{partner.extraLabel}}</div>
                                                </ng-template>

                                            </p-autoComplete>

                                            <br>
                                            <mat-error style="margin-left: 25px;"
                                                *ngIf="getFormControls('EngPartnerReqName').invalid && 
                                                (getFormControls('EngPartnerReqName').dirty || getFormControls('EngPartnerReqName').touched)"
                                                class="ValidationError">
                                                <mat-error class="mat-error"
                                                    *ngIf="getFormControls('EngPartnerReqName').errors?.['required']">
                                                    Please enter Eng Partner Name
                                                </mat-error>
                                            </mat-error>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="mb-3 col-md-6">
                                            <label>A8. Engagement Manager (EM) Name<span class="required">
                                                    *</span></label>
                                            <div class="mb-3 col-md-5">

                                                <!--<input class="form-control" formControlName="EngagementCode" placeholder="Engagement Code">-->
                                                <p-autoComplete [minLength]="4" emptyMessage="No Record Found"
                                                    formControlName="EngManagerName" [suggestions]="ManagerList"
                                                    emptyMessage="No Record Found" class="Vertical_margin"
                                                    (completeMethod)="SearchManagerName($event)"
                                                    (onSelect)="getManagerDetails($event)" [field]="'EmpName'"
                                                    (onClear)="ResetManagerDetails()"
                                                    placeholder="Search for Eng Manager" [forceSelection]="true">
                                                </p-autoComplete>
                                                <br>

                                                <mat-error style="margin-left: 25px;"
                                                    *ngIf="getFormControls('EngManagerName').invalid && 
                                                (getFormControls('EngManagerName').dirty || getFormControls('EngManagerName').touched)"
                                                    class="ValidationError">
                                                    <mat-error class="mat-error"
                                                        *ngIf="getFormControls('EngManagerName').errors?.['required']">
                                                        Please enter Eng Manager Name
                                                    </mat-error>
                                                </mat-error>
                                            </div>
                                        </div>
                                        <div class="mb-3 col-md-6">
                                            <label>
                                                A9. Is this an Independence restricted client?
                                                <span class="required">*</span>
                                            </label>
                                            <div class="input-group radio-div" style="margin-left: 15px;">
                                                <mat-radio-group formControlName="IsIndependenceRestrictedClient">
                                                    <mat-radio-button value="1">Yes</mat-radio-button>
                                                    <mat-radio-button value="2">No</mat-radio-button>
                                                </mat-radio-group>
                                            </div>
                                            <mat-error style="margin-left: 25px;"
                                                *ngIf="getFormControls('IsIndependenceRestrictedClient').invalid && (getFormControls('IsIndependenceRestrictedClient').dirty || getFormControls('IsIndependenceRestrictedClient').touched)"
                                                class="ValidationError">
                                                <mat-error class="mat-error"
                                                    *ngIf="getFormControls('IsIndependenceRestrictedClient').errors?.['required']">
                                                    This field is mandatory
                                                </mat-error>
                                            </mat-error>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="mb-3 col-md-6">
                                            <label>
                                                A10. Is this a G360 Account?
                                                <span class="required">*</span>
                                            </label>
                                            <div class="input-group radio-div" style="margin-left: 15px;">
                                                <mat-radio-group formControlName="IsG360Client">
                                                    <mat-radio-button value="1">Yes</mat-radio-button>
                                                    <mat-radio-button value="2">No</mat-radio-button>
                                                </mat-radio-group>
                                            </div>
                                            <mat-error style="margin-left: 25px;" *ngIf="getFormControls('IsG360Client').invalid 
                                                && (getFormControls('IsG360Client').dirty 
                                                || getFormControls('IsG360Client').touched)" class="ValidationError">
                                                <mat-error class="mat-error"
                                                    *ngIf="getFormControls('IsG360Client').errors?.['required']">
                                                    This field is mandatory
                                                </mat-error>
                                            </mat-error>
                                        </div>

                                        <div class="mb-3 col-md-6">
                                            <label>
                                                A11. Is this a new client or existing client?
                                                <span class="required">*</span>
                                            </label>
                                            <div class="input-group radio-div" style="margin-left: 15px;">
                                                <mat-radio-group (change)="onExistingClientSelectedOrNot($event)"
                                                    formControlName="IsClientNew">
                                                    <mat-radio-button value="1">New Client</mat-radio-button>
                                                    <mat-radio-button value="2">Existing Client</mat-radio-button>
                                                </mat-radio-group>
                                            </div>
                                            <mat-error style="margin-left: 25px;" *ngIf="getFormControls('IsClientNew').invalid 
                                                    && (getFormControls('IsClientNew').dirty 
                                                    || getFormControls('IsClientNew').touched)"
                                                class="ValidationError">
                                                <mat-error class="mat-error"
                                                    *ngIf="getFormControls('IsClientNew').errors?.['required']">
                                                    This field is mandatory
                                                </mat-error>
                                            </mat-error>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </mat-tab>

                        <mat-tab [disabled]="IsContractualScreenDisabled">
                            <ng-template mat-tab-label>
                                <span class="custom-tab-label">(B) Contractual Arrangement & <br> Scope Details</span>
                            </ng-template>
                            <div class="panel panel-default">
                                <div class="panel-body" style="margin: 20px;">
                                    <!--2. Generic Mandatory Validation Message-->
                                    <ng-container *ngIf="getMissingRequiredFields('contractual') as missingFields">
                                        <div class="validation-summary" role="alert" *ngIf="missingFields.length">
                                            <strong>Please complete the following required fields:</strong>
                                            <ul>
                                                <li *ngFor="let field of missingFields">{{ field.label }}</li>
                                            </ul>
                                        </div>
                                    </ng-container>
                                    <!--2. Generic Mandatory Validation Message-->
                                    <div class="row">
                                        <div class="mb-3 col-md-12">
                                            <label>
                                                B1. Are these changes in the GTCs proposed in a standalone Engagement
                                                Agreement (EA) or Master Service Agreement (MSA)?
                                                <span class="required">*</span>
                                            </label>
                                            <div class="input-group radio-div" style="margin-left: 20px;">
                                                <mat-radio-group (change)="onGTCProposedSelected($event)"
                                                    formControlName="IsGTCProposedForEAOrMSA">
                                                    <mat-radio-button value="1">Standalone Engagement Agreement (EA)
                                                    </mat-radio-button>
                                                    <mat-radio-button value="2">Master Service Agreement
                                                        (MSA)</mat-radio-button>
                                                </mat-radio-group>
                                            </div>
                                            <mat-error style="margin-left: 25px;" *ngIf="getFormControls('IsGTCProposedForEAOrMSA').invalid 
                                                && (getFormControls('IsGTCProposedForEAOrMSA').dirty 
                                                || getFormControls('IsGTCProposedForEAOrMSA').touched)"
                                                class="ValidationError">
                                                <mat-error class="mat-error"
                                                    *ngIf="getFormControls('IsGTCProposedForEAOrMSA').errors?.['required']">
                                                    This field is mandatory
                                                </mat-error>
                                            </mat-error>
                                        </div>
                                    </div>
                                    <div class="row" *ngIf="IsGTCProposed">
                                        <div class="mb-3 col-md-11">


                                            <label>
                                                B1.1. Please confirm if it is a TAX exclusive MSA or does this MSA
                                                cover other service lines as well? For example, Consulting, SaT,
                                                etc.
                                                <span class="required"></span>
                                            </label>
                                            <div class="input-group radio-div" style="margin-left: 20px;">
                                                <mat-radio-group formControlName="TaxExclusiveForMSA">
                                                    <mat-radio-button value="1">Tax Exclusive MSA</mat-radio-button>
                                                    <div>
                                                        <mat-radio-button value="2">Includes Other Service Line
                                                            (SL)</mat-radio-button>
                                                        <mat-error
                                                            *ngIf="getFormControls('TaxExclusiveForMSA').value === '2'">
                                                            Also, consult with the quality team of relevant Service
                                                            Line(s) for approval.
                                                        </mat-error>
                                                    </div>
                                                </mat-radio-group>
                                            </div>
                                            <mat-error style="margin-left: 25px;" *ngIf="getFormControls('TaxExclusiveForMSA').invalid 
                                                    && (getFormControls('TaxExclusiveForMSA').dirty
                                                     || getFormControls('TaxExclusiveForMSA').touched)"
                                                class="ValidationError">
                                                <mat-error class="mat-error"
                                                    *ngIf="getFormControls('TaxExclusiveForMSA').errors?.['required']">
                                                    This field is mandatory
                                                </mat-error>
                                            </mat-error>

                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="input-group">
                                            <label style="margin-right:20px ;">B2. What is the tenure (in months) for
                                                this agreement?<span class="required">*</span></label>
                                            <input type="text" inputmode="numeric" maxlength="3"
                                                style="margin-top: -10px; max-width: fit-content;"
                                                class="form-control col-md-2 b2-input" formControlName="TenureInMonths"
                                                (beforeinput)="preventInvalidNumericInput($event, 'TenureInMonths', 3)"
                                                (input)="restrictNumericInput($event, 'TenureInMonths', 3)">
                                            <mat-error
                                                *ngIf="getFormControls('TenureInMonths').invalid 
                                                && (getFormControls('TenureInMonths').dirty || getFormControls('TenureInMonths').touched)"
                                                class="ValidationError b2-validation-error">
                                                <mat-error class="mat-error"
                                                    *ngIf="getFormControls('TenureInMonths').errors?.['required']">
                                                    Please enter some value
                                                </mat-error>
                                                <mat-error class="mat-error"
                                                    *ngIf="getFormControls('TenureInMonths').errors?.['value']">
                                                    Please enter Description/Specification
                                                </mat-error>
                                                <mat-error class="mat-error"
                                                    *ngIf="getFormControls('TenureInMonths').errors?.['pattern']">
                                                    Please enter a numeric value with a maximum of 3 digits.
                                                </mat-error>
                                            </mat-error>
                                            <mat-error class="ValidationError b2-validation-error"
                                                *ngIf="tenureDigitLimitExceeded">
                                                Please enter a numeric value with a maximum of 3 digits.
                                            </mat-error>
                                        </div>
                                        &nbsp;
                                        <div class="mb-3 col-md-12">
                                            <label>B3. Explain the scope of work in brief below.
                                                Also attach the draft
                                                scope for reference.<span class="required">*</span></label>
                                            <div class="input-group">
                                                <textarea class="form-control" formControlName="ScopeOfWorkInBrief"
                                                    maxlength="1000"
                                                    style="resize:none; height: 80px; border-color: black; margin-left: 25px;"></textarea>

                                            </div>
                                            <mat-error style="margin-left: 25px;"
                                                *ngIf="getFormControls('ScopeOfWorkInBrief').invalid 
                                                && (getFormControls('ScopeOfWorkInBrief').dirty || getFormControls('ScopeOfWorkInBrief').touched)"
                                                class="ValidationError">

                                                <mat-error class="mat-error"
                                                    *ngIf="getFormControls('ScopeOfWorkInBrief').errors?.['required']">
                                                    Please enter Description/Specification
                                                </mat-error>
                                                <mat-error class="mat-error"
                                                    *ngIf="getFormControls('ScopeOfWorkInBrief').errors?.['maxlength']">
                                                    Please enter Description/Specification
                                                </mat-error>
                                                <mat-error
                                                    *ngIf="getFormControls('ScopeOfWorkInBrief').hasError('invalidName')">
                                                    Special characters not allowed!
                                                </mat-error>
                                            </mat-error>
                                        </div>

                                    </div>
                                    <div class="row">

                                        <div class="mb-3 col-md-12">

                                            <div class="input-group">

                                                <a type="button" mat-raised-button style="margin-left: 25px;"
                                                    (click)="OpenDialog('ScopeOfWorkInBriefAttachment',
                                                               this.GTCForm.get('ScopeOfWorkInBriefAttachment')?.value.length,
                                                               this.GTCForm.get('ScopeOfWorkInBriefAttachment')?.value)">
                                                    Upload draft EA
                                                </a>
                                                &nbsp;
                                                <div mat-raised-button
                                                    matTooltip="Attach draft EA/MSA (with detailed scope of work) highlighting the proposed changes in the GTCs, along with GCO comments.">
                                                    <i class="pi pi-question-circle"></i>
                                                </div>
                                                &nbsp; &nbsp;

                                                <a mat-mini-fab color="accent" class="matIcon"
                                                    (click)="OpenDialog('ScopeOfWorkInBriefAttachment',
                                                                                        this.GTCForm.get('ScopeOfWorkInBriefAttachment')?.value.length,
                                                                                        this.GTCForm.get('ScopeOfWorkInBriefAttachment')?.value)">
                                                    {{this.GTCForm.get('ScopeOfWorkInBriefAttachment')?.value.length}}
                                                </a>
                                            </div>
                                            <mat-error style="margin-left: 25px;"
                                                *ngIf="getFormControls('ScopeOfWorkInBriefAttachment').invalid 
                                                && (getFormControls('ScopeOfWorkInBriefAttachment').dirty || getFormControls('ScopeOfWorkInBriefAttachment').touched)"
                                                class="ValidationError">
                                                <mat-error class="mat-error"
                                                    *ngIf="getFormControls('ScopeOfWorkInBriefAttachment').errors?.['required']">
                                                    This field is required.
                                                </mat-error>
                                            </mat-error>

                                        </div>
                                    </div>


                                    <div class="row">
                                        <div class="input-group col-md-12">
                                            <label style="margin-right:5px ;">B4. What is the risk profile of this
                                                engagement?</label>
                                            <div mat-raised-button
                                                matTooltip="You may refer ‘Conclusion’ tab in PACE and mention the risk involved in this engagement">
                                                <i class="pi pi-question-circle"></i>
                                            </div>
                                            <p-dropdown [options]="riskProfiles"
                                                (onChange)="onRiskInvlovedClick($event)" autoWidth="false"
                                                placeholder="Select Risk Profile" optionLabel="label"
                                                optionValue="value"
                                                formControlName="RiskProfileEngagement"></p-dropdown>

                                            <!-- <mat-error
                                                *ngIf="getFormControls('RiskProfileEngagement').invalid
                                                && (getFormControls('RiskProfileEngagement').dirty || getFormControls('RiskProfileEngagement').touched)"
                                                class="ValidationError">
                                                <mat-error class="mat-error"
                                                    *ngIf="getFormControls('RiskProfileEngagement').errors?.['required']">
                                                    Please select risk profile engagement
                                                </mat-error>
                                            </mat-error> -->

                                            <!-- <input style="margin-top: -10px;"  class="form-control col-md-4"
                                                formControlName="RiskProfileEngagement" readonly [disabled]="true"> -->
                                        </div>
                                        <div *ngIf="IsRiskInvlovedTextBoxShown">
                                            <div class="mb-3 col-md-12">
                                                <label>B4.1. Explain the risk involved in this engagement.</label>
                                                <div class="input-group">
                                                    <textarea class="form-control" maxlength="1000"
                                                        formControlName="DetailsOfRiskInvolvedInEng"
                                                        style="resize:none; height: 80px; border-color: black; margin-left: 30px;"></textarea>
                                                    &nbsp;
                                                    <div mat-raised-button
                                                        matTooltip="Please refer ‘Conclusion’ tab in PACE and mention the risk involved in this engagement.">
                                                        <i class="pi pi-question-circle"></i>
                                                    </div>
                                                </div>

                                                <mat-error style="margin-left: 25px;"
                                                    *ngIf="getFormControls('DetailsOfRiskInvolvedInEng').invalid 
                                                    && (getFormControls('DetailsOfRiskInvolvedInEng').dirty || getFormControls('DetailsOfRiskInvolvedInEng').touched)"
                                                    class="ValidationError">


                                                    <mat-error class="mat-error"
                                                        *ngIf="getFormControls('DetailsOfRiskInvolvedInEng').errors?.['required']">
                                                        Please enter Description/Specification
                                                    </mat-error>
                                                    <mat-error class="mat-error"
                                                        *ngIf="getFormControls('DetailsOfRiskInvolvedInEng').errors?.['maxlength']">
                                                        Please enter Description/Specification
                                                    </mat-error>
                                                    <mat-error
                                                        *ngIf="getFormControls('DetailsOfRiskInvolvedInEng').hasError('invalidName')">
                                                        Special characters not allowed!
                                                    </mat-error>
                                                </mat-error>
                                            </div>
                                        </div>
                                    </div>
                                    <br>
                                    <div class="row">
                                        <div class="input-group col-md-12">
                                            <label style="margin-right:20px ;">B5. What is the expected fees (in INR)
                                                from the client under this agreement for
                                                Tax services?<span class="required">*</span></label>
                                            <div class="b5-field">
                                                <input type="text" inputmode="numeric" maxlength="10"
                                                    class="form-control" formControlName="ExpectedFeesFromClient"
                                                    (beforeinput)="preventInvalidNumericInput($event, 'ExpectedFeesFromClient', 10)"
                                                    (input)="restrictNumericInput($event, 'ExpectedFeesFromClient', 10)">
                                                <mat-error
                                                    *ngIf="getFormControls('ExpectedFeesFromClient').invalid 
                                                    && (getFormControls('ExpectedFeesFromClient').dirty || getFormControls('ExpectedFeesFromClient').touched)"
                                                    class="ValidationError b5-validation-error">

                                                    <mat-error class="mat-error"
                                                        *ngIf="getFormControls('ExpectedFeesFromClient').errors?.['required']">
                                                        Enter value in INR
                                                    </mat-error>
                                                    <mat-error class="mat-error"
                                                        *ngIf="getFormControls('ExpectedFeesFromClient').errors?.['value']">
                                                        Enter value in INR
                                                    </mat-error>
                                                    <mat-error class="mat-error"
                                                        *ngIf="getFormControls('ExpectedFeesFromClient').errors?.['pattern']">
                                                        Please enter a numeric value with a maximum of 10 digits.
                                                    </mat-error>
                                                </mat-error>
                                                <mat-error class="ValidationError b5-validation-error"
                                                    *ngIf="expectedFeesDigitLimitExceeded">
                                                    Please enter a numeric value with a maximum of 10 digits.
                                                </mat-error>
                                            </div>
                                        </div>
                                    </div>
                                    <br>
                                    <div class="row" *ngIf="IsGTCProposed">
                                        <div class="input-group col-md-12">
                                            <label style="margin-right:20px ;">B6. What is the expected fees (in INR)
                                                from this client
                                                for Tax services over a 12-month period?<span
                                                    class="required">*</span></label>
                                            <div class="b5-field">
                                                <input type="text" inputmode="numeric" maxlength="10"
                                                    class="form-control"
                                                    formControlName="ExpectedFeesFromClientForTaxServices"
                                                    (beforeinput)="preventInvalidNumericInput($event, 'ExpectedFeesFromClientForTaxServices', 10)"
                                                    (input)="restrictNumericInput($event, 'ExpectedFeesFromClientForTaxServices', 10)">
                                                <mat-error *ngIf="getFormControls('ExpectedFeesFromClientForTaxServices').invalid 
                                                    && (getFormControls('ExpectedFeesFromClientForTaxServices').dirty 
                                                    || getFormControls('ExpectedFeesFromClientForTaxServices').touched)"
                                                    class="ValidationError b5-validation-error">

                                                    <mat-error class="mat-error"
                                                        *ngIf="getFormControls('ExpectedFeesFromClientForTaxServices').errors?.['required']">
                                                        Enter value in INR
                                                    </mat-error>
                                                    <mat-error class="mat-error"
                                                        *ngIf="getFormControls('ExpectedFeesFromClientForTaxServices').errors?.['pattern']">
                                                        Please enter a numeric value with a maximum of 10 digits.
                                                    </mat-error>
                                                </mat-error>
                                                <mat-error class="ValidationError b5-validation-error"
                                                    *ngIf="expectedFeesTaxServicesDigitLimitExceeded">
                                                    Please enter a numeric value with a maximum of 10 digits.
                                                </mat-error>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </mat-tab>

                        <mat-tab [disabled]="IsProposedScreenDisabled">
                            <ng-template mat-tab-label>
                                <span class="custom-tab-label">(C) Proposed Changes <br> In GTCs</span>
                            </ng-template>
                            <div class="panel panel-default">
                                <div class="panel-body" style="margin: 20px;">
                                    <!--2. Generic Mandatory Validation Message-->
                                    <ng-container *ngIf="getMissingRequiredFields('proposedChanges') as missingFields">
                                        <div class="validation-summary" role="alert" *ngIf="missingFields.length">
                                            <strong>Please complete the following required fields:</strong>
                                            <ul>
                                                <li *ngFor="let field of missingFields">{{ field.label }}</li>
                                            </ul>
                                        </div>
                                    </ng-container>
                                    <!--2. Generic Mandatory Validation Message-->

                                    <div class="row">
                                        <div class="mb-3 col-md-11">

                                            <div class="d-flex align-items-start">
                                                <label style="min-width: 25px; margin-bottom: 0;">C1.</label>

                                                <label style="margin-bottom: 0; flex: 1;">
                                                    What is the level of push back done for these proposed changes?
                                                    Has the EP/India TAL (Tax Account Leader) / India CSP (Client
                                                    Service Partner)
                                                    discussed the proposed changes with the client?
                                                    <span class="required">*</span>
                                                </label>
                                            </div>

                                            <textarea class="form-control" formControlName="PushBackDone"
                                                maxlength="1000"
                                                style="resize:none; height: 80px; border-color: black; margin-left: 25px;"></textarea>
                                            <mat-error style="margin-left: 25px;"
                                                *ngIf="getFormControls('PushBackDone').invalid && (getFormControls('PushBackDone').dirty || getFormControls('PushBackDone').touched)"
                                                class="ValidationError">
                                                <mat-error class="mat-error"
                                                    *ngIf="getFormControls('PushBackDone').errors?.['required']">
                                                    Please enter Description/Specification
                                                </mat-error>
                                                <mat-error class="mat-error"
                                                    *ngIf="getFormControls('PushBackDone').errors?.['maxlength']">
                                                    Description can be max 5000 character.
                                                </mat-error>
                                                <mat-error
                                                    *ngIf="getFormControls('PushBackDone').hasError('invalidName')">
                                                    Special characters not allowed!
                                                </mat-error>
                                            </mat-error>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="mb-3 col-md-12">
                                            <div class="d-flex align-items-start">
                                                <label style="min-width: 30px; margin-bottom: 0;">C1.1.</label>

                                                <label style="margin-bottom: 0; flex: 1;">
                                                    Please attach evidence of pushback done with the client on the
                                                    proposed changes and/or India TAL (Tax Account Leader) / India CSP
                                                    (ClientService Partner) consultations.
                                                    <span class="required">*</span>
                                                </label>
                                            </div>

                                            <div class="d-flex">
                                                <div style="min-width: 38px;"></div>
                                                <div class="input-group">
                                                    <a type="button" mat-raised-button
                                                        (click)="OpenDialog('PushBackAttachment',this.GTCForm.get('PushBackAttachment')?.value.length,this.GTCForm.get('PushBackAttachment')?.value)">
                                                        Upload Document
                                                    </a> &nbsp; &nbsp; &nbsp;<a mat-mini-fab class="matIcon"
                                                        color="accent"
                                                        (click)="OpenDialog('PushBackAttachment',this.GTCForm.get('PushBackAttachment')?.value.length,this.GTCForm.get('PushBackAttachment')?.value)">
                                                        {{this.GTCForm.get('PushBackAttachment')?.value.length}}
                                                    </a>
                                                </div>
                                            </div>
                                            <mat-error style="margin-left: 25px;"
                                                *ngIf="getFormControls('PushBackAttachment').invalid
                                                && (getFormControls('PushBackAttachment').dirty || getFormControls('PushBackAttachment').touched)"
                                                class="ValidationError">
                                                <mat-error class="mat-error"
                                                    *ngIf="getFormControls('PushBackAttachment').errors?.['required']">
                                                    This field is required.
                                                </mat-error>
                                            </mat-error>
                                        </div>
                                    </div>


                                    <div class="row"
                                        *ngIf="isProposedChangesFieldVisible('IsAcceptanceForChangesInPast')">
                                        <div class="mb-3 col-md-10">
                                            <label>
                                                {{IsAcptForChangesInPast ? 'C2.' : ''}} Have we accepted the exact
                                                changes in the past?
                                                <span class="required">*</span>
                                            </label>
                                            <div class="input-group radio-div" style="margin-left: 25px;">
                                                <mat-radio-group (change)="onChangesInPast($event)"
                                                    formControlName="IsAcceptanceForChangesInPast">
                                                    <mat-radio-button value="1">Yes</mat-radio-button>
                                                    <mat-radio-button value="2">No</mat-radio-button>
                                                    <mat-radio-button value="3">
                                                        Changes partially
                                                        accepted
                                                    </mat-radio-button>
                                                </mat-radio-group>
                                            </div>
                                            <mat-error style="margin-left: 25px;" *ngIf="getFormControls('IsAcceptanceForChangesInPast').invalid
                                                    && (getFormControls('IsAcceptanceForChangesInPast').dirty
                                                    || getFormControls('IsAcceptanceForChangesInPast').touched)"
                                                class="ValidationError">
                                                <mat-error class="mat-error"
                                                    *ngIf="getFormControls('IsAcceptanceForChangesInPast').errors?.['required']">
                                                    This field is mandatory
                                                </mat-error>
                                            </mat-error>
                                        </div>
                                    </div>
                                    <div class="row"
                                        *ngIf="isProposedChangesFieldVisible('ApprDtlForTaxQualityLOL')">
                                        <div class="mb-3 col-md-12">
                                            <label>
                                                C2.1. Attach the latest approvals obtained from Tax Quality team and
                                                other LOL grid approvers. In case the approvals were not obtained,
                                                please explain the reason for the same. <span class="required">*</span>
                                            </label>
                                            <div class="input-group">
                                                <textarea class="form-control" maxlength="1000"
                                                    formControlName="ApprDtlForTaxQualityLOL"
                                                    style="resize:none; height: 80px; border-color: black; margin-right: 10px;"></textarea>

                                            </div>

                                            <mat-error style="margin-left: 25px;"
                                                *ngIf="getFormControls('ApprDtlForTaxQualityLOL').invalid
                                                && (getFormControls('ApprDtlForTaxQualityLOL').dirty || getFormControls('ApprDtlForTaxQualityLOL').touched)"
                                                class="ValidationError">
                                                <mat-error class="mat-error"
                                                    *ngIf="getFormControls('ApprDtlForTaxQualityLOL').errors?.['required']">
                                                    Please enter Description/Specification
                                                </mat-error>
                                                <mat-error class="mat-error"
                                                    *ngIf="getFormControls('ApprDtlForTaxQualityLOL').errors?.['maxlength']">
                                                    Please enter Description/Specification
                                                </mat-error>
                                                <mat-error
                                                    *ngIf="getFormControls('ApprDtlForTaxQualityLOL').hasError('invalidName')">
                                                    Special characters not allowed!
                                                </mat-error>
                                            </mat-error>
                                        </div>

                                        <div class="mb-3 col-md-5">

                                            <div class="input-group">

                                                <a type="button" mat-raised-button
                                                    (click)="OpenDialog('ApprDtlForTaxQualityLOLAttachment',this.GTCForm.get('ApprDtlForTaxQualityLOLAttachment')?.value.length,this.GTCForm.get('ApprDtlForTaxQualityLOLAttachment')?.value)">
                                                    Upload Document
                                                </a> &nbsp; &nbsp; &nbsp;<a mat-mini-fab class="matIcon" color="accent"
                                                    (click)="OpenDialog('ApprDtlForTaxQualityLOLAttachment',this.GTCForm.get('ApprDtlForTaxQualityLOLAttachment')?.value.length,this.GTCForm.get('ApprDtlForTaxQualityLOLAttachment')?.value)">
                                                    {{this.GTCForm.get('ApprDtlForTaxQualityLOLAttachment')?.value.length}}
                                                </a>
                                            </div>
                                            <mat-error style="margin-left: 25px;"
                                                *ngIf="getFormControls('ApprDtlForTaxQualityLOLAttachment').invalid
                                                && (getFormControls('ApprDtlForTaxQualityLOLAttachment').dirty || getFormControls('ApprDtlForTaxQualityLOLAttachment').touched)"
                                                class="ValidationError">
                                                <mat-error class="mat-error"
                                                    *ngIf="getFormControls('ApprDtlForTaxQualityLOLAttachment').errors?.['required']">
                                                    This field is required.
                                                </mat-error>
                                            </mat-error>

                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="mb-3 col-md-12">
                                            <label>
                                                {{IsAcptForChangesInPast ? 'C3.' : 'C2.'}} Are the changes in the
                                                standard GTCs approved and reviewed by the
                                                GCO?
                                                <span class="required">*</span>
                                            </label>
                                            <div class="input-group radio-div" style="margin-left: 25px;">
                                                <mat-radio-group (change)="onAcceptanceClick($event)"
                                                    formControlName="IsGTCApprovedGCO">
                                                    <mat-radio-button value="1">Yes</mat-radio-button>
                                                    <mat-radio-button value="2">No</mat-radio-button>

                                                </mat-radio-group>
                                            </div>
                                            <mat-error style="margin-left: 25px;" *ngIf="getFormControls('IsGTCApprovedGCO').invalid
                                                && (getFormControls('IsGTCApprovedGCO').dirty
                                                || getFormControls('IsGTCApprovedGCO').touched)"
                                                class="ValidationError">
                                                <mat-error class="mat-error"
                                                    *ngIf="getFormControls('IsGTCApprovedGCO').errors?.['required']">
                                                    This field is mandatory
                                                </mat-error>
                                            </mat-error>
                                        </div>
                                    </div>
                                    <div class="row"
                                        *ngIf="isProposedChangesFieldVisible('AttachGCOAttachment')">
                                        <div class="mb-3 col-md-12">
                                            <div class="input-group">
                                                <label style="margin-right:20px;">
                                                    {{IsAcptForChangesInPast ? 'C3.1.' : 'C2.1.'}} Attach GCO approval
                                                    email/comments
                                                    on the proposed changes. <span class="required">*</span>
                                                </label>
                                                <a type="button" [disabled]="IsBusinessCaseReason" mat-raised-button
                                                    (click)="OpenDialog('AttachGCOAttachment',
                                                               this.GTCForm.get('AttachGCOAttachment')?.value.length,
                                                               this.GTCForm.get('AttachGCOAttachment')?.value)">
                                                    Upload Document
                                                </a> &nbsp; &nbsp; &nbsp;<a mat-mini-fab class="matIcon" color="accent"
                                                    [disabled]="IsBusinessCaseReason"
                                                    (click)="OpenDialog('AttachGCOAttachment',
                                                                                        this.GTCForm.get('AttachGCOAttachment')?.value.length,
                                                                                        this.GTCForm.get('AttachGCOAttachment')?.value)">
                                                    {{this.GTCForm.get('AttachGCOAttachment')?.value.length}}
                                                </a>
                                            </div>
                                            <mat-error style="margin-left: 25px;"
                                                *ngIf="getFormControls('AttachGCOAttachment').invalid
                                                && (getFormControls('AttachGCOAttachment').dirty || getFormControls('AttachGCOAttachment').touched)"
                                                class="ValidationError">
                                                <mat-error class="mat-error"
                                                    *ngIf="getFormControls('AttachGCOAttachment').errors?.['required']">
                                                    This field is required.
                                                </mat-error>
                                            </mat-error>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="mb-3 col-md-11">
                                            <label>
                                                {{IsAcptForChangesInPast ? 'C4.' : 'C3.'}} Provide the business case
                                                for accepting the proposed changes.
                                            </label>
                                            <textarea class="form-control" maxlength="1000"
                                                formControlName="BusinessCaseAcceptanceReason"
                                                style="resize:none; height: 80px; border-color: black; margin-left: 25px;"></textarea>
                                            <mat-error style="margin-left: 25px;"
                                                *ngIf="getFormControls('BusinessCaseAcceptanceReason').invalid
                                                && (getFormControls('BusinessCaseAcceptanceReason').dirty || getFormControls('BusinessCaseAcceptanceReason').touched)"
                                                class="ValidationError">
                                                <mat-error class="mat-error"
                                                    *ngIf="getFormControls('BusinessCaseAcceptanceReason').errors?.['required']">
                                                    Please enter Description/Specification
                                                </mat-error>
                                                <mat-error class="mat-error"
                                                    *ngIf="getFormControls('BusinessCaseAcceptanceReason').errors?.['maxlength']">
                                                    Please enter Description/Specification
                                                </mat-error>
                                                <mat-error
                                                    *ngIf="getFormControls('BusinessCaseAcceptanceReason').hasError('invalidName')">
                                                    Special characters not allowed!
                                                </mat-error>
                                            </mat-error>
                                        </div>
                                    </div>
                                    <div class="row" *ngIf="IsAddCluaseButtonShow">
                                        <div class="container">
                                            <div class="btn-holder">
                                                <button mat-stroked-button type="button" class="btn-primary1"
                                                    [disabled]="IsAddCaluseButtonDisable"
                                                    (click)="OnAddClauseClicked()">
                                                    + Add Clause & Change
                                                    Request
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="mb-3 col-md-6">
                                            <u>List of added clause & change request </u>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="mb-3 col-md-12" style="margin: 10px 0 10px 0;">
                                            <div class="table-container">
                                                <mat-table #table [dataSource]="ClauseViewList" matSort>
                                                    <ng-container matColumnDef="ClauseNo" mat-sort-header>
                                                        <mat-header-cell *matHeaderCellDef>Clause No</mat-header-cell>
                                                        <mat-cell *matCellDef="let element" data-label="ClauseNo">


                                                            <a style="cursor: pointer;"
                                                                (click)="onClauseNavigate(element.ClauseNo)"
                                                                class="pi">{{element.ClauseNo}}</a>
                                                        </mat-cell>
                                                    </ng-container>
                                                    <ng-container matColumnDef="PaceID" mat-sort-header>
                                                        <mat-header-cell *matHeaderCellDef>Pace ID</mat-header-cell>
                                                        <mat-cell *matCellDef="let element" data-label="PaceID:">
                                                            {{element.PaceID}}
                                                        </mat-cell>
                                                    </ng-container>
                                                    <ng-container matColumnDef="EntityName" mat-sort-header>
                                                        <mat-header-cell *matHeaderCellDef>Entity Name</mat-header-cell>
                                                        <mat-cell *matCellDef="let element" data-label="EntityName:">
                                                            {{element.EntityName}}
                                                        </mat-cell>
                                                    </ng-container>
                                                    <ng-container matColumnDef="CreatedOn" mat-sort-header>
                                                        <mat-header-cell *matHeaderCellDef>Created On</mat-header-cell>
                                                        <mat-cell *matCellDef="let element" data-label="CreatedOn:">
                                                            {{element.CreatedOn}}
                                                        </mat-cell>
                                                    </ng-container>
                                                    <ng-container matColumnDef="Delete" mat-sort-header>
                                                        <mat-header-cell *matHeaderCellDef>Action</mat-header-cell>
                                                        <mat-cell *matCellDef="let element" data-label="Action:">
                                                            <i href="" (click)="onRemove(element)"
                                                                *ngIf="global.IsEngTeam && (RecordStatus == 1 || IsReturnRequest)"
                                                                class="pi pi-trash"
                                                                style="position: absolute;cursor: pointer;"></i>
                                                        </mat-cell>
                                                    </ng-container>

                                                    <mat-header-row
                                                        *matHeaderRowDef="displayedColumns;sticky: true"></mat-header-row>
                                                    <mat-row *matRowDef="let row; columns: displayedColumns;"
                                                        [class.hide]="!row.IsActive"></mat-row>
                                                </mat-table>
                                            </div>
                                            <!-- <mat-paginator [length]="resultsLength" [pageSize]="30"></mat-paginator> -->
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </mat-tab>
                        <mat-tab *ngIf="IsExceptionalRequired" [disabled]="IsExceptionalScreenDisabled">
                            <ng-template mat-tab-label>
                                <span class="custom-tab-label">(D) Exceptional <br> Approval</span>
                            </ng-template>
                            <div class="panel panel-default">
                                <div class="panel-body" style="margin: 20px;">
                                    <!--2. Generic Mandatory Validation Message-->
                                    <ng-container
                                        *ngIf="getMissingRequiredFields('exceptionalApproval') as missingFields">
                                        <div class="validation-summary" role="alert" *ngIf="missingFields.length">
                                            <strong>Please complete the following required fields:</strong>
                                            <ul>
                                                <li *ngFor="let field of missingFields">{{ field.label }}</li>
                                            </ul>
                                        </div>
                                    </ng-container>
                                    <!--2. Generic Mandatory Validation Message-->
                                    <div class="row">
                                        <div class="mb-3 col-md-6">
                                            <label>
                                                D1. Is this an exceptional approval?
                                                <span class="required"></span>
                                            </label>
                                            <div class="input-group radio-div">
                                                <mat-radio-group formControlName="IsExceptionalApprovalRequired"
                                                    (change)="OnExceptionalApprovalChange($event)">
                                                    <mat-radio-button value="1">Yes</mat-radio-button>
                                                    <mat-radio-button value="2">No</mat-radio-button>
                                                </mat-radio-group>
                                            </div>
                                            <mat-error style="margin-left: 25px;" *ngIf="getFormControls('IsExceptionalApprovalRequired').invalid
                                                && (getFormControls('IsExceptionalApprovalRequired').dirty
                                                 || getFormControls('IsExceptionalApprovalRequired').touched)"
                                                class="ValidationError">
                                                <mat-error class="mat-error"
                                                    *ngIf="getFormControls('IsExceptionalApprovalRequired').errors?.['required']">
                                                    This field is mandatory
                                                </mat-error>
                                            </mat-error>
                                        </div>
                                    </div>
                                    <div>
                                        <section class="example-section">

                                            <span class="example-list-section">

                                                <h4>Limitation of Liability</h4>
                                                <mat-checkbox value="1" [checked]="IsIndirectDamages"
                                                    [disabled]="IsDisableExpProp" (change)="toggle($event)"
                                                    class="example-margin">
                                                    Indirect Damages
                                                </mat-checkbox>




                                            </span>
                                        </section>
                                        <section class="example-section">
                                            <span class="example-list-section">
                                                <mat-checkbox value="2" [checked]="IsDirectDamages"
                                                    [disabled]="IsDisableExpProp" (change)="toggle($event)"
                                                    class="example-margin">
                                                    High LOL Cap (Explain the limit in free text box
                                                    below)
                                                </mat-checkbox>

                                            </span>
                                        </section>

                                        <section class="example-section">
                                            <span class="example-list-section">

                                                <mat-checkbox value="3" [checked]="IsUnlimitedLiability"
                                                    [disabled]="IsDisableExpProp" (change)="toggle($event)"
                                                    class="example-margin">
                                                    Unlimited liability for breach of confidentiality for
                                                    ASP/GSP services
                                                </mat-checkbox>
                                            </span>
                                        </section>

                                        <section class="example-section">
                                            <span class="example-list-section">

                                                <mat-checkbox value="4" [checked]="IsMutualLiability"
                                                    [disabled]="IsDisableExpProp" (change)="toggle($event)"
                                                    class="example-margin">
                                                    Mutual liability without indemnity
                                                    carveout
                                                </mat-checkbox>
                                            </span>
                                        </section>


                                        <section class="example-section">

                                            <span class="example-list-section">
                                                <h4>Indemnity</h4>

                                                <mat-checkbox value="5" [checked]="IsDeletionIndemnity"
                                                    [disabled]="IsDisableExpProp" (change)="toggle($event)"
                                                    class="example-margin">
                                                    Deletion of indemnity clause
                                                </mat-checkbox>





                                            </span>
                                        </section>




                                        <section class="example-section">
                                            <span class="example-list-section">
                                            </span>
                                            <mat-checkbox value="6" [checked]="IsCappingOfIndemnity"
                                                [disabled]="IsDisableExpProp" (change)="toggle($event)"
                                                class="example-margin">
                                                Capping of indemnity clause
                                            </mat-checkbox>
                                        </section>

                                        <section class="example-section">
                                            <span class="example-list-section">
                                            </span>
                                            <mat-checkbox value="7" [checked]="IsReciprocalLimitation"
                                                [disabled]="IsDisableExpProp" (change)="toggle($event)"
                                                class="example-margin">
                                                Reciprocal indemnity
                                            </mat-checkbox>
                                        </section>


                                        <section class="example-section">
                                            <h4>Confidentiality</h4>
                                            <span class="example-list-section">

                                                <mat-checkbox value="8" [checked]="IsPerpetualConfidentiality"
                                                    [disabled]="IsDisableExpProp" (change)="toggle($event)"
                                                    class="example-margin">
                                                    Perpetual confidentiality
                                                </mat-checkbox>




                                            </span>
                                        </section>

                                        <section class="example-section">
                                            <span class="example-list-section">
                                                <mat-checkbox value="9" [checked]="IsIncreaseConfidentiality"
                                                    [disabled]="IsDisableExpProp" (change)="toggle($event)"
                                                    class="example-margin">
                                                    Increase in confidentiality period
                                                </mat-checkbox>
                                            </span>
                                        </section>



                                        <section class="example-section">
                                            <h4>Others</h4>

                                            <span class="example-list-section">
                                                <mat-checkbox value="10" [checked]="IsDual" (change)="toggle($event)"
                                                    [disabled]="IsDisableExpProp" class="example-margin">
                                                    Dual
                                                    protection on certain accounts
                                                </mat-checkbox>
                                            </span>

                                        </section>

                                        <section class="example-section">
                                            <span class="example-list-section">
                                                <mat-checkbox value="11" [checked]="IsOthers" (change)="toggle($event)"
                                                    [disabled]="IsDisableExpProp"
                                                    class="example-margin">Others</mat-checkbox>
                                            </span>

                                        </section>
                                    </div>
                                    <div class="row">
                                        <div class="mb-3 col-md-12">
                                            <label>
                                                D2. Exceptional approval details.<span class="required">*</span>
                                            </label>
                                            <div class="input-group">
                                                <textarea class="form-control" formControlName="ExceptionalDetails"
                                                    maxlength="1000" [readonly]="IsDisableExpProp"
                                                    style="resize:none; height: 80px; border-color: black; margin-right: 10px;"></textarea>
                                            </div>
                                            <mat-error style="margin-left: 25px;"
                                                *ngIf="getFormControls('ExceptionalDetails').invalid
                                                && (getFormControls('ExceptionalDetails').dirty || getFormControls('ExceptionalDetails').touched)"
                                                class="ValidationError">

                                                <mat-error class="mat-error"
                                                    *ngIf="getFormControls('ExceptionalDetails').errors?.['required']">
                                                    Please enter Description/Specification
                                                </mat-error>
                                                <mat-error class="mat-error"
                                                    *ngIf="getFormControls('ExceptionalDetails').errors?.['maxlength']">
                                                    Please enter Description/Specification
                                                </mat-error>
                                                <mat-error
                                                    *ngIf="getFormControls('ExceptionalDetails').hasError('invalidName')">
                                                    Special characters not allowed!
                                                </mat-error>
                                            </mat-error>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </mat-tab>
                        <mat-tab *ngIf="IsTQLComments" [disabled]="IsExceptionalScreenDisabled">
                            <ng-template mat-tab-label>
                                <span class="custom-tab-label">TQ Leader <br> Comments</span>
                            </ng-template>
                            <div class="panel panel-default">
                                <div class="panel-body tq-comments-original" style="margin: 20px;">
                                    <div class="row">
                                        <div class="mb-3 col-sm-12" *ngFor="let dataMain of ClauseViewList">
                                            <div class="cardSearchMain">
                                                <div class="card-headerMain form-control" data-bs-toggle="collapse"
                                                    attr.href="#{{'ABCD' + dataMain.GtcID}}" role="button"
                                                    aria-expanded="false"
                                                    attr.aria-controls="#{{'ABCD' + dataMain.GtcID}}">
                                                    <header class="panel-heading">
                                                        <label class="panel-title">{{dataMain.ClauseNo}}</label>
                                                        <span class="tq-collapse-icon"><i
                                                                class="pi pi-arrow-down"></i></span>
                                                    </header>
                                                </div>
                                                <div class="collapse" id="{{'ABCD' + dataMain.GtcID}}">
                                                    <div class="mb-3 col-sm-12"
                                                        *ngFor="let data of dataMain.ClauseDetailsList">
                                                        <div class="cardSearch">
                                                            <div class="card-header form-control"
                                                                data-bs-toggle="collapse"
                                                                attr.href="#{{'ABC' + data.ClauseNumber.toString()}}"
                                                                role="button" aria-expanded="false"
                                                                attr.aria-controls="#{{'ABC' + data.ClauseNumber.toString()}}">
                                                                <header class="panel-heading">
                                                                    <label class="panel-title">{{"Standard Clause: " +
                                                                        data.ClauseNumber}}</label>
                                                                    &nbsp;&nbsp;
                                                                    <span *ngIf="data.ClauseStatus == 1"
                                                                        style="font-size: medium;color: green;">(Approved)</span>
                                                                    <span *ngIf="data.ClauseStatus == 2"
                                                                        style="font-size: medium;color: red;">(Rejected)</span>
                                                                    <span *ngIf="data.ClauseStatus == 3"
                                                                        style="font-size: medium;color: darkred;">(Pushback)</span>
                                                                    <span class="tq-collapse-icon"><i
                                                                            class="pi pi-arrow-down"></i></span>
                                                                </header>
                                                            </div>
                                                            <div class="collapse"
                                                                id="{{'ABC' + data.ClauseNumber.toString()}}">
                                                                <div class="rowAltr tq-radio-row">
                                                                    <div class="mb-3 col-md-10">
                                                                        <div class="input-group radio-div">
                                                                            <mat-radio-group [value]="data.ClauseRadioType">
                                                                                <mat-radio-button value="1">Modify Clause</mat-radio-button>
                                                                                <mat-radio-button value="2">Delete Clause</mat-radio-button>
                                                                                <mat-radio-button value="3">No Change</mat-radio-button>
                                                                                <mat-radio-button value="4">Add sub clause</mat-radio-button>
                                                                            </mat-radio-group>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="rowfd tq-comments-fields">
                                                                    <div class="rowAltr tq-comments-field tq-proposed-edits">
                                                                        <div class="mb-3 col-md-12 tq-field-label">
                                                                            <div class="input-group">
                                                                                <label>Proposed Edits by Client</label>
                                                                                &nbsp;
                                                                                <div mat-raised-button
                                                                                        matTooltip="Changes will appear in track mode in 'Modified Clause' section below once you click on Save button.">
                                                                                    <i class="pi pi-question-circle"></i>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div class="mb-3 col-md-12 tq-field-control">
                                                                            <textarea class="form-control" readonly>{{data.Description}}</textarea>
                                                                        </div>
                                                                    </div>
                                                                    <div class="rowAltr tq-comments-field tq-modified-clause"
                                                                        *ngIf="data.ClauseRadioType == 1 || data.ClauseRadioType == 4">
                                                                        <div class="mb-3 col-md-12 tq-field-label">
                                                                            <div class="input-group">
                                                                                <label>Modified Clause</label>
                                                                                &nbsp;
                                                                                <div mat-raised-button
                                                                                        matTooltip="Changes will appear automatically once you click on Save button.">
                                                                                    <i class="pi pi-question-circle"></i>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div class="mb-3 col-md-12 tq-field-control">
                                                                            <div class="form-control tq-modified-content"
                                                                                [innerHTML]="data.ProposedByClientDesc">
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="rowAltr tq-comments-field tq-add-clause"
                                                                        *ngIf="data.ClauseRadioType == 4">
                                                                        <div class="mb-3 col-md-12 tq-field-label">
                                                                            <label>Add Clause/Sub Clause</label>
                                                                        </div>
                                                                        <div class="mb-3 col-md-12 tq-field-control">
                                                                            <textarea class="form-control" readonly>{{data.SubClauseDec}}</textarea>
                                                                        </div>
                                                                    </div>
                                                                    <div class="rowAltr tq-comments-field tq-gco-comments"
                                                                        *ngIf="data.ClauseRadioType == 1 || data.ClauseRadioType == 4 || data.ClauseRadioType == 2">
                                                                        <div class="mb-3 col-md-12 tq-field-label">
                                                                            <div class="input-group">
                                                                                <label>GCO Comments on the proposed changes</label>
                                                                                &nbsp;
                                                                                <div mat-raised-button
                                                                                        matTooltip="GCO comments on the proposed change- (Provide reference (page/ para number, document name, email dated etc) to the document with GCO comments).">
                                                                                    <i class="pi pi-question-circle"></i>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div class="mb-3 col-md-12 tq-field-control">
                                                                            <textarea class="form-control" readonly>{{data.GCOComment}}</textarea>
                                                                        </div>
                                                                    </div>
                                                                    <div class="rowAltr tq-comments-field tq-risk-plan"
                                                                        *ngIf="data.ClauseRadioType == 1 || data.ClauseRadioType == 4 || data.ClauseRadioType == 2">
                                                                        <div class="mb-3 col-md-12 tq-field-label">
                                                                            <div class="input-group">
                                                                                <label>Risk Mitigation Action Plan <span
                                                                                        class="required">*</span></label>
                                                                                &nbsp;
                                                                                <div mat-raised-button
                                                                                        matTooltip="Risk Mitigation Action Plan - (Engagement teams' comments on the risk mitigation steps to be undertaken to manage increased risk. You may refer to the indicative risk mitigation action plan available in the India Tax Manual).">
                                                                                    <i class="pi pi-question-circle"></i>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div class="mb-3 col-md-12 tq-field-control">
                                                                            <textarea class="form-control" readonly>{{data.RiskMitigationActionPlan}}</textarea>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="rowAltr tq-quality-comments">
                                                                    <div class="mb-3 col-md-12 tq-field-label">
                                                                        <label>Tax Quality Comments</label>
                                                                    </div>
                                                                    <div class="mb-3 col-md-12 tq-field-control">
                                                                        <textarea class="form-control" readonly>{{data.TaxQualityLeaderComments}}</textarea>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </mat-tab>
                    </mat-tab-group>
                </fieldset>
            </form>
        </mat-card>

        <ng-template #returnRejectRequest>
            <header class="panel-heading" style="margin: 5px;">
                <h5 class="panel-title">Reason for
                    {{SelectedAction==Return?'Return':(SelectedAction==Reject?'Reject':'Partially Approve')}}</h5>
            </header>
            <div class="row" style="margin: 5px;">
                <div class="col-md-12">
                    <textarea type="text" class="form-control" maxlength="500" placeholder=""
                        [(ngModel)]="RejectReturnReason" style="resize:none; height: 110px;"></textarea>
                </div>
            </div>
            <br>
            <footer class="panel-footer" style="margin: 5px;">
                <button class="btn-primary1" mat-stroked-button type="button"
                    (click)="ChangeApprovalStatus(SelectedAction)">
                    Submit
                </button>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <button class="btn-primary1" mat-stroked-button type="button"
                    (click)="CancelRejectReturn()">Cancel</button>
            </footer>
        </ng-template>

        <ng-template #sendToTQL>
            <header class="panel-heading" style="margin: 5px;">
                <h5 class="panel-title">Send To TQL Remarks</h5>
            </header>
            <div class="row" style="margin: 5px;">
                <div class="col-md-12">
                    <textarea type="text" class="form-control" maxlength="500" placeholder=""
                        [(ngModel)]="SendTOTQLReson" style="resize:none; height: 110px;"></textarea>
                </div>
            </div>
            <br>
            <footer class="panel-footer" style="margin: 5px;">
                <button class="btn-primary1" mat-stroked-button type="button"
                    (click)="SendToTQLWithReasons(SelectedAction)">
                    Submit
                </button>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <button class="btn-primary1" mat-stroked-button type="button"
                    (click)="CancelRejectReturn()">Cancel</button>
            </footer>
        </ng-template>

        <ng-template #TakeActionOnRequest>
            <div style="margin: 10px;">
                <header class="panel-heading" style="margin: 10px;">
                    <h5 class="panel-title">TQ Comments</h5>
                </header>
                <div class="row">
                    <div class="col-md-12">
                        <textarea type="text" class="form-control" maxlength="500" placeholder=""
                            [(ngModel)]="TQComments" style="resize:none; height: 110px;"></textarea>
                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="input-group col-md-12">
                        <label style="margin-right:20px ;">Consulted with TQL/GCO/Independence/Risk Management
                            team?<span class="required">*</span></label>
                        <mat-radio-group (change)="onConstrutedChange($event)" [(ngModel)]="IsConsultedForTQApproval">
                            <mat-radio-button value="1">Yes</mat-radio-button>
                            <mat-radio-button value="2">No</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row" style="margin: 5px;">
                    <div class="input-group">
                        <a type="button" mat-raised-button
                            (click)="OpenDialog('ApproveWithTQCommentsAttachment',this.GTCForm.get('ApproveWithTQCommentsAttachment')?.value.length,this.GTCForm.get('ApproveWithTQCommentsAttachment')?.value)">
                            Upload Document
                        </a> &nbsp; &nbsp; &nbsp;<a mat-mini-fab class="matIcon" color="accent"
                            (click)="OpenDialog('ApproveWithTQCommentsAttachment',this.GTCForm.get('ApproveWithTQCommentsAttachment')?.value.length,this.GTCForm.get('ApproveWithTQCommentsAttachment')?.value)">
                            {{this.GTCForm.get('ApproveWithTQCommentsAttachment')?.value.length}}
                        </a>
                    </div>
                    <mat-error style="margin-left: 25px;"
                        *ngIf="getFormControls('ApproveWithTQCommentsAttachment').invalid 
                        && (getFormControls('ApproveWithTQCommentsAttachment').dirty || getFormControls('ApproveWithTQCommentsAttachment').touched)"
                        class="ValidationError">
                        <mat-error class="mat-error"
                            *ngIf="getFormControls('ApproveWithTQCommentsAttachment').errors?.['required']">
                            This field is required.
                        </mat-error>
                    </mat-error>
                </div>
                <div class="row" style="margin: 5px;"
                    *ngIf="(global.IsTQApprover || global.IsAdmin) && SelectedAction != PendingWithTQL">
                    <small style="color: red; margin-left: 5px;"><b>Any attachment added below by TQ will be shared
                            with engagement team over email sent from the tool.</b></small>
                    <div class="input-group">
                        <a type="button" mat-raised-button
                            (click)="OpenDialog('TQApproverAttachment',this.GTCForm.get('TQApproverAttachment')?.value.length,this.GTCForm.get('TQApproverAttachment')?.value)">
                            Add Attachment
                        </a> &nbsp; &nbsp; &nbsp;<a mat-mini-fab class="matIcon" color="accent"
                            (click)="OpenDialog('TQApproverAttachment',this.GTCForm.get('TQApproverAttachment')?.value.length,this.GTCForm.get('TQApproverAttachment')?.value)">
                            {{this.GTCForm.get('TQApproverAttachment')?.value.length}}
                        </a>
                    </div>
                </div>
                <br>
                <footer class="panel-footer">
                    <button class="btn-primary1" mat-stroked-button type="button"
                        (click)="ChangeApprovalStatus(SelectedAction)">
                        Submit
                    </button>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <button class="btn-primary1" mat-stroked-button type="button"
                        (click)="CancelRejectReturn()">Cancel</button>
                </footer>
            </div>
        </ng-template>
    </div>
</div>
